import {
  LoyaltyLevel,
  LoyaltyLevelPrizeLabel,
  LoyaltyLevelPrizeValues,
  loyaltyLevels,
} from './data';
import { CompPoints, User } from '@/api/auth';
import { CMSGroupsConfig, MissionBlockI } from '@/api/cms/loyalty';
import { filterByGroup, parseGroup } from '@/helpers/cms';

export const MISSION_PARAM = 'missions[]';
export const MIN_PROGRESS = 0;
export const MAX_PROGRESS = 100;

export enum MissionMode {
  DEFAULT,
  ACTIVE,
  DONE,
}

export interface LoyaltyDataI {
  level: number;
  nextLevel: number;
  prizeValues?: LoyaltyLevelPrizeValues;
  prizeLabel: LoyaltyLevelPrizeLabel;
  nextPrizeValues?: LoyaltyLevelPrizeValues;
  nextPrizeLabel: LoyaltyLevelPrizeLabel;
  currentCompPoints: number;
  fromCompPoints: number;
  toCompPoints: number;
}

export const detectLoyaltyData =
  (levelsData: LoyaltyLevel[]) =>
  (compPoints?: CompPoints): LoyaltyDataI => {
    const points = compPoints?.persistent?.points || 0;

    const currentIndexPoint = levelsData.findIndex(
      ({ cp }, index) =>
        points &&
        cp <= points &&
        (!levelsData[index + 1] || points < levelsData[index + 1].cp)
    );

    const {
      level = 0,
      prizeLabel,
      prizeValues,
      cp = 0,
    } = levelsData[currentIndexPoint] || {};
    const nextLevel = levelsData[currentIndexPoint + 1];

    return {
      level: level,
      nextLevel: nextLevel?.level || level + 1,
      prizeLabel: prizeLabel,
      prizeValues: prizeValues,
      nextPrizeLabel: nextLevel?.prizeLabel,
      nextPrizeValues: nextLevel?.prizeValues,
      currentCompPoints: points,
      fromCompPoints: cp,
      toCompPoints: nextLevel?.cp || points,
    };
  };

export const generateLoyaltyData = detectLoyaltyData(loyaltyLevels);

type CheckByUserGroupsArgs = Pick<
  MissionBlockI,
  keyof CMSGroupsConfig | 'showGuestToggle' | 'onlyGuestAvailable'
>;

export const checkByUserGroups =
  (user?: User) =>
  ({
    groupsIncludeMode,
    groupsInclude,
    groupsExcludeMode,
    groupsExclude,
    showGuestToggle,
    onlyGuestAvailable,
  }: CheckByUserGroupsArgs) => {
    if (!user || !user?.statuses) return onlyGuestAvailable || showGuestToggle;

    if (onlyGuestAvailable) return false;

    const parsedGroupsInclude = parseGroup(groupsInclude);
    const parsedGroupsExclude = parseGroup(groupsExclude);

    const includeResult =
      !parsedGroupsInclude.length ||
      filterByGroup(parsedGroupsInclude, groupsIncludeMode, user.statuses);

    const excludeResult =
      !parsedGroupsExclude.length ||
      !filterByGroup(parsedGroupsExclude, groupsExcludeMode, user.statuses);

    return includeResult && excludeResult;
  };
